<fui-switch-control [disabled]="isReadonly" [label]="label" [(ngModel)]="value">
</fui-switch-control>
